// Core component styles
const coreStyles = {
    container: {
        display: 'flex',
        flexShrink: 0,
    },
};

/**
 * Helper method to get the styles for Activity Indicator component
 * @param {Object} contextStyles - Context styles for Activity Indicator Component
 */
const getStyles = (contextStyles = {}) => {
    return {
        container: {
            ...coreStyles.container,
            ...contextStyles.container,
        },
    };
};

export default getStyles;
